export function cleanObject(object: any) {
  return Object.keys(object).reduce((acc: any, key) => {
    if (object[key] !== null && object[key] !== undefined) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
}
